export const addFailedUpdateDataToTableData = (tableData, failedUpdateData) => {
  if (!failedUpdateData) {
    return tableData;
  }
  const updateDataIds = new Map(
    failedUpdateData.map((obj) => [obj.blockAssignmentId, obj])
  );
  const updatedDataWithFailedUpdates = tableData.map((row) =>
    updateDataIds.has(row.blockAssignmentId)
      ? updateDataIds.get(row.blockAssignmentId)
      : row
  );
  return updatedDataWithFailedUpdates;
};
